
import React from "react";
import ReactDOM from "react-dom";
import { Button, Form } from "semantic-ui-react";

const rootContainer = document.getElementById("root-container");
const userEmail = rootContainer.getAttribute("data-user-email");
const userFirstname = rootContainer.getAttribute("data-user-firstname");
const userLastname = rootContainer.getAttribute("data-user-lastname");


const isLoggedIn = !!userEmail;

const handleSubmit = (e) => {
  e.preventDefault();

  const formData = new FormData(e.target);
  if (isLoggedIn) {
    formData.set("email", userEmail);
    formData.set("firstname", userFirstname);
    formData.set("lastname", userLastname);
  }

  fetch("/support", {
    method: "POST",
    body: formData,
  })
    .then((res) => {
      if (res.ok) {
        alert("Vielen Dank für Ihre Nachricht!");
        window.location.reload();
      } else {
        alert("Fehler beim Senden der Nachricht.");
      }
    })
    .catch(() => alert("Fehler beim Senden der Nachricht."));
};

ReactDOM.render(
  <Form onSubmit={handleSubmit}>
    <Form.Input
      label="Vorname"
      name="firstname"
      placeholder="Ihr Vorname"
      defaultValue={userFirstname}
      readOnly={isLoggedIn}
      required
    />
    <Form.Input
      label="Nachname"
      name="lastname"
      placeholder="Ihr Nachname"
      defaultValue={userLastname}
      readOnly={isLoggedIn}
      required
    />
    <Form.Input
      label="E-Mail"
      name="email"
      type="email"
      placeholder="Ihre E-Mail"
      defaultValue={userEmail}
      readOnly={isLoggedIn}
      required
    />
    <Form.Input
      label="Betreff"
      name="subject"
      placeholder="Betreff"
      required
    />
    <Form.TextArea
      label="Nachricht"
      name="message"
      placeholder="Ihre Nachricht"
      required
    />
    <Button type="submit">Absenden</Button>
  </Form>,
  rootContainer
);
